import { ServiceResult } from '../models';
import {
  RecipeMenuHeaderPrivateUser,
  UpdateRecipeMenuHeaderPrivateUsersRequest,
} from '../models/recipe-menu-header-private-users';
import ApiService from './api-service';

class RecipeMenuHeaderPrivateUserService extends ApiService {
  private static classInstance: RecipeMenuHeaderPrivateUserService;

  private constructor() {
    super('RecipeMenuHeaderPrivateUser');
  }

  public static getInstance(): RecipeMenuHeaderPrivateUserService {
    if (!this.classInstance) {
      this.classInstance = new RecipeMenuHeaderPrivateUserService();
    }
    return this.classInstance;
  }

  public getRecipeMenuHeaderPrivateUser(
    recipeMenuHeaderPrivateUserId: string,
    viewAsCustomerId: string
  ): ServiceResult<RecipeMenuHeaderPrivateUser> {
    return this.get(
      `${this.baseUrl}/GetRecipeMenuHeaderPrivateUser?recipeMenuHeaderPrivateUserId=${recipeMenuHeaderPrivateUserId}&viewAsCustomerId=${viewAsCustomerId}`
    );
  }

  public getRecipeMenuHeaderPrivateUsers(
    recipeMenuHeaderId: string,
    viewAsCustomerId: string
  ): ServiceResult<RecipeMenuHeaderPrivateUser[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeMenuHeaderPrivateUsers?recipeMenuHeaderId=${recipeMenuHeaderId}&viewAsCustomerId=${viewAsCustomerId}`
    );
  }

  public updateRecipeMenuHeaderPrivateUsers(
    request: UpdateRecipeMenuHeaderPrivateUsersRequest
  ): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/UpdateRecipeMenuHeaderPrivateUsers`, request);
  }
}

export default RecipeMenuHeaderPrivateUserService;
